import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { PedidoService } from 'src/app/services/pedido.service';
import { Purchase } from 'src/app/models/purchase';
import { SituacaoCompra } from 'src/app/shared/enums/situacao-compra.enum';
import { Router, ActivatedRoute } from '@angular/router';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
  selector: 'app-extrato-compra-list',
  templateUrl: './extrato-compra-list.component.html',
  styleUrls: ['./extrato-compra-list.component.css']
})
export class ExtratoCompraListComponent implements OnInit {

  private currentUser: Auth;

  public filtroDataProcessamento = '';
  public purchases: Purchase[] = [];
  public SituacaoCompra = SituacaoCompra;

  //#region Paginação
  public offSet = 0;
  public currentPage = 1;
  showItem = '10';
  //#endregion

  constructor(
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    private pedidoService: PedidoService,
    private router: Router) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.pageChanged();
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  applyFilter(dataProcessamento: string) {
    this.filtroDataProcessamento = dataProcessamento;

    this.pageChanged();
  }

  pageChanged() {
    /*let filter = new ExtratoCompraFilterOptions();
    filter.releasedate = this.filtroDataProcessamento;*/

    this.alertService.clear();
/*
    let purchasesRequestModel = new PurchaseRequestModel();
    purchasesRequestModel.extratoCompraFilterOptions = filter;
    purchasesRequestModel.situacaoCompraEnums = [this.SituacaoCompra.ParcialmenteProcessado, this.SituacaoCompra.ProcessadoComSucesso];
    purchasesRequestModel.cedenteGuid = this.currentUser.token.assignorGuid;
    purchasesRequestModel.gestorGuid = this.currentUser.token.userReferenceId;*/

    this.pedidoService.getPurcharses([this.SituacaoCompra.ParcialmenteProcessado, this.SituacaoCompra.ProcessadoComSucesso],
      this.currentUser.token.assignorGuid,this.offSet,this.showItem).subscribe(
      response => {

        if (response.status === ApiError.Sucesso) {
          this.purchases = response.result.purchases;
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!'); }
    );
  }

  details(item: Purchase) {
    this.router.navigate([`portal/minhasrecargas/details/${item.purchaseId}`]);
  }

  //#region Paginacao
  changePage(event) {
    this.currentPage = event;
    this.offSet = this.currentPage - 1;
    this.pageChanged();
  }

  changeLimit(event){
    this.showItem = event;
    this.currentPage = this.currentPage;
    this.offSet = this.currentPage - 1;
    this.pageChanged();
  }
  //#endregion

}
